import { forwardRef } from 'react';

import { ButtonBase, ButtonBaseElement, ButtonBaseProps } from './ButtonBase.js';
import { ButtonHotkey } from './ButtonHotkey.js';

export type ButtonElement = ButtonBaseElement;
export interface ButtonProps extends ButtonBaseProps {
  hotkey?: string;
}

export const Button = forwardRef<ButtonElement, ButtonProps>(
  ({ hotkey, ...restProps }, forwardedRef) => {
    return hotkey ? (
      <ButtonHotkey ref={forwardedRef} {...restProps} hotkey={hotkey} />
    ) : (
      <ButtonBase ref={forwardedRef} {...restProps} />
    );
  }
);
